import graphql__926a46666b7e5ccb77c6 from "./__generated__/ContributionLocationMap_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import { Marker } from "react-leaflet";

import MapBase from "../Maps/MapBase";
import MapElementIcon from "../Maps/MapElementIcon";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import MapContextProvider from "../Maps/MapContext";

const ContributionLocationMap = props => {
  const contribution = useFragment(
    ContributionLocationMap_contribution,
    props.contribution
  );
  const { hasLocation, latitude, longitude, theme, map } = contribution;
  const { className } = props;

  const { newContributionMarkerStyle } = map || {};

  const iconStyle = theme?.style || newContributionMarkerStyle;

  const { isDesktop } = useResponsiveFlag();
  const mapHeight = isDesktop ? 300 : 150;

  // Do not render the preview for contributions that are not bound to a map nor a
  // location
  if (!iconStyle || !hasLocation) return null;

  const position = [latitude, longitude];
  const icon = MapElementIcon({ iconStyle }, { tooltipAnchor: [0, 0] });

  // The style={{ height }} is needed because of a semicolon bug that is
  // rendered.
  //
  // TODO : Find why this semicolon is rendered ...
  //
  return (
    <div className={className} style={{ mapHeight }}>
      <MapContextProvider map={map}>
        <MapBase
          map={map}
          height={mapHeight}
          centerLatitude={latitude}
          centerLongitude={longitude}
          staticMap={true}
        >
          <Marker icon={icon} position={position} />
        </MapBase>
      </MapContextProvider>
    </div>
  );
};

const ContributionLocationMap_contribution = graphql__926a46666b7e5ccb77c6;

export default ContributionLocationMap;
